<template>
  <div class="animated fadeIn">
    <b-form-group label="Address" :label-cols="2">
      <b-form-input
        v-model="address_line_one"
        type="text"
        placeholder="Address"
      />
    </b-form-group>
    <b-form-group label="Address Line #2" :label-cols="2">
      <b-form-input
        v-model="address_line_two"
        type="text"
        placeholder="Line #2"
      />
    </b-form-group>
    <b-form-group label="City/Town" :label-cols="2">
      <b-form-input
        v-model="address_city"
        type="text"
        placeholder="City/Town"
      />
    </b-form-group>
    <b-form-group label="Country" :label-cols="2">
      <multiselect
        v-model="selected_country"
        :options="country_options"
        :multiple="false"
      />
    </b-form-group>
    <b-form-group label="Province/State" :label-cols="2">
      <multiselect
        v-model="selected_region"
        :options="region_options"
        :multiple="false"
      />
    </b-form-group>
    <b-form-group label="Postal Code" :label-cols="2">
      <b-form-input
        type="text"
        v-model="address_postal"
        placeholder="Postal Code"
      />
    </b-form-group>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import country_data from '@/shared/_countries'

export default {
  name: "AddressForm",
  components: {
    Multiselect
  },
  props: {
    form_data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    selected_country: {
      get() {
        return this.form_data.country;
      },
      set(value) {
        this.updateFormData("country", value);
        !value && this.updateFormData("region", null);
      } 
    },
    selected_region: {
      get() {
        return this.form_data.region;
      },
      set(value) {
        this.updateFormData("region", value);
      } 
    },
    address_line_one: {
      get() {
        return this.form_data.address;
      },
      set(value) {
        this.updateFormData('address', value);
      }
    },
    address_line_two: {
      get() {
        return this.form_data.address2;
      },
      set(value) {
        this.updateFormData('address2', value);
      }
    },
    address_city: {
      get() {
        return this.form_data.city;
      },
      set(value) {
        this.updateFormData('city', value);
      }
    },
    address_postal: {
      get() {
        return this.form_data.postal;
      },
      set(value) {
        this.updateFormData('postal', value);
      }
    },
    country_options() {
      return country_data.map(country => country.countryName)
    },
    region_options() {
      return this.form_data.country
        ? country_data.find(country => country.countryName === this.form_data.country).regions.map(region => region.name)
        : []
    }
  },
  methods: {
    getFormId(prefix) {
      return `${prefix}_${this.getParentIndex}`;
    },
    updateFormData(field, value) {
      this.$emit("updateFormData", { field, value });
    }
  }
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
